import React from 'react';
import AssignKPITemplate from './Assign_KPI_Employee';
import '../../../CommonCSS/SocietyCSS.css'

const Assign_KPI_EmpApp = () => {
  return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Assign KPI Template To Employee</h5>
          </div>
        </div>
        <AssignKPITemplate/>
      </div>
    </div >
  );
};

export default Assign_KPI_EmpApp;
